import store from "@/store";

export default [
  {
    path: "/logout",
    redirect: "/signout",
  },
  {
    path: "/signout",
    beforeEnter: (to, from, next) => {
      store.dispatch("cognito/signOut").then(() => next("/signin"));
    },
  },
];
